// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loaderContainer--Ux7GH","loader":"loader--__rZ2","noData":"noData--G2efh"};